import { useTheme } from '@mui/material/styles';
import { themeAlpine, themeQuartz } from 'ag-grid-community';

/**
 * Simple hook that applies MUI colors and border radius to AG Grid
 */
export const useAgGridMuiTheme = () => {
  const muiTheme = useTheme();
  const isDark = muiTheme.palette.mode === 'dark';
  const baseTheme = isDark ? themeQuartz : themeAlpine;

  return baseTheme.withParams({
    backgroundColor: muiTheme.palette.background.paper,
    rowHoverColor: muiTheme.palette.primary.light,
    selectedRowBackgroundColor: muiTheme.palette.primary.light,
    foregroundColor: muiTheme.palette.text.primary,
    headerBackgroundColor: muiTheme.palette.background.paper,
    headerTextColor: muiTheme.palette.text.primary,
    borderColor: muiTheme.palette.divider,
    borderWidth: 1,
    columnBorder: { color: muiTheme.palette.divider },
    wrapperBorder: 'none',
    wrapperBorderRadius: 0,
    accentColor: muiTheme.palette.primary.main,
  });
};
